import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Badge } from 'reactstrap';
import useAxios from '../../hooks/useAxios';
import FetchStatus from '../../components/fetchStatus/FetchStatus';

const Tab3 = () => {
  //   const [annualLeaveKuota, setAnnualLeaveKuota] = useState(0);
  //   const [year, setYear] = useState(0);
  const api = useAxios();

  const { isLoading, error, data } = useQuery({
    queryKey: ['leave-balance'],
    queryFn: () =>
      api.get(`leave-balance`).then((res) => {
        // setAnnualLeaveKuota(res.data.total_kuota);
        // setYear(res.data.data_year);
        return res.data.data;
      }),
  });

  return (
    <div className="d-flex flex-column gap-3">
      {isLoading ? (
        <FetchStatus type="loading" />
      ) : error ? (
        <FetchStatus type="empty" />
      ) : (
        <div className="row g-3">
          {/* Saldo Cuti */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex flex-column align-items-center justify-content-between bg-success rounded-4 p-4 h-100 text-white">
              <div className="d-flex flex-column align-items-center justify-content-center h-100">
                <h4 className="text-white text-center">Saldo Cuti</h4>
                <h1 className="text-white fw-bold" style={{ fontSize: '3rem' }}>
                  {data?.total_saldo}
                </h1>
              </div>
              <div className="d-flex bg-light-success rounded-4 p-2 w-100 align-items-center justify-content-center mt-3">
                <span className="text-success text-center w-100">
                  Periode : {data?.periode_start} - {data?.periode_end}
                </span>
              </div>
            </div>
          </div>

          {/* Periode Aktif */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex flex-column gap-3 bg-light p-3 rounded-4 h-100">
              <span>Periode Aktif</span>
              <div className="d-flex flex-column align-items-start bg-light-primary p-3 rounded-4">
                <span className="text-dark text-center">Kuota</span>
                <span className="fw-bold text-primary fs-2">{data?.quota}</span>
              </div>
              <div className="d-flex flex-column align-items-start bg-light-primary p-3 rounded-4">
                <span className="text-dark text-center">Penggunaan</span>
                <span className="fw-bold text-primary fs-2">{data?.quota_used}</span>
              </div>
            </div>
          </div>

          {/* Periode Sebelumnya */}
          <div className="col-12 col-lg-4">
            <div className="d-flex flex-column gap-3 bg-light p-3 rounded-4 h-100">
              <span>Periode Sebelumnya</span>
              <div className="d-flex flex-column align-items-start bg-light-primary p-3 rounded-4">
                <div className="d-flex w-100 justify-content-between">
                  <span className="text-dark text-center">Sisa Kuota</span>
                  {data?.is_carry_over_valid !== true && data?.carry_over > 0 && (
                    <Badge color="danger">Expired</Badge>
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <span className="fw-bold text-primary fs-2">{data?.carry_over}</span>
                  {data?.carry_over > 0 && (
                    <span className="fw-light text-dark fs-6">
                      Hingga {data?.carry_over_valid_until}
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex flex-column align-items-start bg-light-primary p-3 rounded-4">
                <span className="text-dark text-center">Penggunaan</span>
                <span className="fw-bold text-primary fs-2">{data?.carry_over_used}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tab3;
